import React from 'react';
import { useStyletron } from 'baseui';
import { Select } from 'baseui/select';
import { Textarea } from 'baseui/textarea';
import { Button } from 'baseui/button';

import { ConfirmationModal, KeyValueEnteringGuide } from 'commons-ui';

import Editor from '../../utils/Editor';
import useCreateKey from './useCreateKey';

const CreateKey: React.FC = () => {
	const {
		PICKER_VALUES,
		pickerValue,
		keyName,
		keyValue,
		confirmationModal,
		hasEditPermission,
		setPickerValue,
		handleKeyNameEnter,
		handleKeyValueEnter,
		clearKey,
		clearValue,
		handleCancelPress,
		handleCreatekey
	} = useCreateKey();

	const [css] = useStyletron();
	const space = css({ marginRight: '20px' });
	const verticalSpace = css({ marginBottom: '10px' });
	const keyHeadings = css({ fontSize: '18px', fontWeight: 'bold', marginRight: '20px', marginTop: '10px' });

	return (
		<div className={css({ margin: '20px', overflow: 'auto', height: 'calc(100% - 130px)' })}>
			{confirmationModal.show && (
				<ConfirmationModal
					confirmationHeader={confirmationModal.header}
					confirmationMessage={confirmationModal.message}
					confirmationDialogOnAgree={confirmationModal.handleAlertConfirmation}
					onClose={confirmationModal.handleAlertCancel}
				/>
			)}
			<h2>Create Key</h2>
			<div className={css({ marginTop: '20px', display: 'flex', alignItems: 'center' })}>
				<span className={keyHeadings}>Please Select the Key type</span>
				<span className={css({ width: '200px' })}>
					<Select
						options={PICKER_VALUES}
						placeholder='Select Key Type'
						onChange={(params) => {
							setPickerValue(params.value);
						}}
						labelKey='id'
						value={pickerValue}
					/>
				</span>
			</div>
			<div>
				<div className={keyHeadings}>Key Name</div>

				<Textarea
					value={keyName}
					onChange={(e) => handleKeyNameEnter(e.currentTarget.value)}
					overrides={{
						Input: {
							style: {
								maxHeight: '100px',
								minHeight: '50px',
								minWidth: '300px',
								width: '100vw', // fill all available space up to parent max-width
								resize: 'both'
							}
						},
						InputContainer: {
							style: {
								maxWidth: '100%',
								width: 'min-content'
							}
						}
					}}
				/>
				<div className={verticalSpace} />
				<Button onClick={clearKey}>Clear key</Button>
				<div className={keyHeadings}>Key Value</div>

				<Editor keyValue={keyValue} handleChangeText={handleKeyValueEnter} pickerValue={pickerValue} hasEditPermission />
				<div className={verticalSpace} />

				<Button onClick={clearValue}>Clear Value</Button>
			</div>
			<div className={css({ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' })}>
				<Button onClick={handleCancelPress}>Cancel</Button>
				<span className={space} />
				{hasEditPermission && <Button onClick={handleCreatekey}>Submit</Button>}
			</div>
			<KeyValueEnteringGuide />
		</div>
	);
};

export default CreateKey;
